var map = {
	"./10_nuts.png": 2503,
	"./1drink_12beer.png": 2504,
	"./1serving_8ounces.png": 2505,
	"./1serving_8ounces2.png": 2506,
	"./1serving_8ounces3.png": 2507,
	"./1serving_8ounces4.png": 2508,
	"./1serving_8ounces5.png": 2509,
	"./8ounces_1glass.png": 2510,
	"./can_1.png": 2511,
	"./can_2.png": 2512,
	"./can_3.png": 2513,
	"./cup.png": 2514,
	"./dried_serving_1/4cup.png": 2515,
	"./dried_serving_1:4cup.png": 2516,
	"./fresh_serving_1cup.png": 2517,
	"./glass_1.png": 2518,
	"./glass_2.png": 2519,
	"./golfball.png": 2520,
	"./halfthumb.png": 2521,
	"./hand_1.png": 2522,
	"./hand_2.png": 2523,
	"./hand_3.png": 2524,
	"./hand_4.png": 2525,
	"./hand_5.png": 2526,
	"./how.png": 865,
	"./serving_1/2cup.png": 2527,
	"./serving_1:2cup.png": 2528,
	"./serving_1tbsp.png": 2529,
	"./serving_3/4ounces.png": 2530,
	"./serving_3:4ounces.png": 2531,
	"./thumbx2.png": 2532,
	"./usda.png": 2533,
	"./vegetables_1cup.png": 2534,
	"./what.png": 863,
	"./wholethumb.png": 2535,
	"./why.png": 864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2502;